import React from 'react';
import classnames from 'classnames';
import s from './Flex.scss';

export interface Props {
  className?: string;
  style?: React.CSSProperties;
  inline?: boolean;
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'baseline'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline';
  wrap?: 'wrap' | 'wrap-reverse' | 'nowrap';
  gap?: number;
  fullWidth?: boolean;
  fullHeight?: boolean;
  flex?: number | string;
  flexGrow?: number;
  flexShrink?: number;
  dataHook?: string;
  innerRef?: React.Ref<HTMLDivElement>;
  'aria-label'?: string;
  role?: string;
  onClick?: (e) => void;
}

const Flex: React.FC<React.PropsWithChildren<Props>> = props => {
  const classNames = classnames(
    s['flex'],
    props.inline && s['inline'],
    props.justifyContent && s[`justify-content-${props.justifyContent}`],
    props.alignItems && s[`align-items-${props.alignItems}`],
    props.direction && s[`direction-${props.direction}`],
    props.wrap && s[`wrap-${props.wrap}`],
    props.fullWidth && s['full-width'],
    props.fullHeight && s['full-height'],
    props.className
  );

  const style = {
    ...(props.gap && { gap: props.gap }),
    ...(props.flex !== undefined && { flex: props.flex }),
    ...(props.flexGrow !== undefined && { flexGrow: props.flexGrow }),
    ...(props.flexShrink !== undefined && { flexShrink: props.flexShrink }),
    ...props.style,
  };

  return (
    <div
      className={classNames}
      role={props.role}
      style={Object.keys(style).length > 0 ? style : undefined}
      data-hook={props.dataHook}
      onClick={props.onClick}
      ref={props.innerRef}
      aria-label={props['aria-label']}
    >
      {props.children}
    </div>
  );
};
Flex.displayName = 'Flex';

export default Flex;
